export const getSx = (sx) => ({
  color: 'text',
  ...sx,
  ':hover': {
    textDecoration: 'underline',
    ...(sx[':hover'] || {}),
  },
});
